import React from 'react';
import './style.scss';
import TodoList from './components/to-do/TodoList';


function App() {
  return (
    <TodoList />
    
  );
}

export default App;
